import { useEffect } from "react";

const STYLE_ID = "redesign-shared-keyframes";

const SHARED_KEYFRAMES = `
  @keyframes offerRing {
    0%, 100% { box-shadow: 0 0 0 3px rgba(52,152,219,0.1); }
    50% { box-shadow: 0 0 0 5px rgba(52,152,219,0.18), 0 0 12px rgba(52,152,219,0.08); }
  }
  @keyframes fadeUp {
    0% { opacity: 0; transform: translateY(14px); }
    100% { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeLeft {
    0% { opacity: 0; transform: translateX(-12px); }
    100% { opacity: 1; transform: translateX(0); }
  }
  @keyframes headerReveal {
    0% { opacity: 0; transform: translateY(-8px); }
    100% { opacity: 1; transform: translateY(0); }
  }
  @keyframes cardReveal {
    0% { opacity: 0; transform: translateY(16px) scale(0.98); }
    100% { opacity: 1; transform: translateY(0) scale(1); }
  }
  @keyframes rowHighlight {
    0% { background-color: rgba(25, 118, 210, 0.12); }
    100% { background-color: transparent; }
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  @keyframes stripPulse {
    0%, 100% { box-shadow: 0 0 0 0 rgba(245,158,11,0.0); }
    50% { box-shadow: 0 0 0 3px rgba(245,158,11,0.12); }
  }
  @keyframes fadeSlideUp {
    0% { opacity: 0; transform: translateY(12px); }
    100% { opacity: 1; transform: translateY(0); }
  }
  @keyframes sidebarSlideIn {
    0% { opacity: 0; transform: translateX(-20px); }
    100% { opacity: 1; transform: translateX(0); }
  }
  @keyframes inProgressBreathe {
    0%, 100% {
      box-shadow: 0 1px 3px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.02), 0 0 0 0 rgba(45,140,78,0);
    }
    50% {
      box-shadow: 0 1px 3px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.02), 0 0 0 6px rgba(45,140,78,0.10), 0 0 16px 2px rgba(45,140,78,0.08);
    }
  }
  @keyframes inProgressSheen {
    /* Animates background-position on the overlay itself (no pseudo, no
       transform, no oversized child). The overlay has a 300%x300%
       background-size linear-gradient with a bright diagonal band. Moving
       the background from top-right (100% 0%) to bottom-left (0% 100%)
       sweeps the band across the card along the top-left→bottom-right
       visual diagonal. Sweep occupies 0–55%, rest 55–100% for an organic
       idle gap. Pure 2D paint — works identically on Windows Chromium,
       Android Chrome, and iOS Safari. No compositor layer promotion,
       no rasterization tile size risk. */
    0% { background-position: 100% 0%; }
    55% { background-position: 0% 100%; }
    100% { background-position: 0% 100%; }
  }
`;

/**
 * Injects shared redesign keyframes (animations).
 * Safe to call from multiple pages — deduplicates automatically.
 */
export function useRedesignSetup(): void {
  useEffect(() => {
    // Inject shared keyframes
    if (!document.getElementById(STYLE_ID)) {
      const style = document.createElement("style");
      style.id = STYLE_ID;
      style.textContent = SHARED_KEYFRAMES;
      document.head.appendChild(style);
    }
  }, []);
}
